const canElementsAnimate = ({ domElements, recordedPositions }) => {
  if (!Object.keys(domElements).length) {
    return false;
  }

  if (!recordedPositions.length) {
    return false;
  }

  return true;
};

export default canElementsAnimate;
